import React from "react";
import { Sparkles } from "lucide-react";
import { CtaButton } from "@/components/CtaButton";
import { SITE } from "@/constants/testIds";

export const HomePackagesSection = ({ packages = [] }) => (
    <section data-testid={SITE.homePackagesPreview} className="py-14 sm:py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl">
                <p className="font-accent text-xs text-terracotta">
                    PACKAGES &amp; CONSULTATIONS
                </p>
                <h2 className="mt-2 font-display text-3xl sm:text-4xl text-moss leading-tight">
                    Choose how to begin
                </h2>
                <p className="mt-3 text-foreground/75 leading-relaxed">
                    Whether you’re just discovering Ayurveda or ready for a deep, sustained healing arc, there’s a starting point built for you.
                </p>
            </div>
            <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-5">
                {packages.map((p, i) => {
                    const isHighlighted = i === 1;
                    const cardClass = isHighlighted
                        ? "border-terracotta/50 bg-cream"
                        : "border-border/80 bg-white/80";
                    return (
                        <div
                            key={p.slug}
                            data-testid={SITE.pricingPlan}
                            className={`rounded-2xl border ${cardClass} p-6 sm:p-7 flex flex-col`}
                        >
                            <span className="inline-flex w-fit rounded-full bg-sand px-3 py-1 text-xs text-moss">
                                {p.badge}
                            </span>
                            <h3 className="mt-4 font-display text-2xl text-moss">{p.name}</h3>
                            <p className="mt-1 text-sm text-foreground/70 leading-relaxed">
                                {p.description}
                            </p>
                            <div className="mt-5 flex items-baseline gap-2">
                                <span className="font-display text-4xl text-moss">{p.price}</span>
                            </div>
                            <ul className="mt-5 space-y-2 text-sm text-foreground/80">
                                {p.includes?.slice(0, 5).map((inc) => (
                                    <li
                                        key={`${p.slug}-${inc}`}
                                        className="flex items-start gap-2"
                                    >
                                        <Sparkles
                                            className="mt-0.5 h-3.5 w-3.5 text-sage shrink-0"
                                            strokeWidth={1.75}
                                        />
                                        <span>{inc}</span>
                                    </li>
                                ))}
                            </ul>
                            <div className="mt-6 pt-2">
                                <CtaButton
                                    to="/contact"
                                    variant={isHighlighted ? "accent" : "primary"}
                                    testid={SITE.pricingCta}
                                    className="w-full"
                                >
                                    Request consultation
                                </CtaButton>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    </section>
);

export default HomePackagesSection;
